module.exports = __webpack_public_path__ + "img/1502962940.4e6efcb7.jpg";